
import { useStore } from 'vuex'

// lodash components
import find from 'lodash/find'

function loanTerms() {
    const store = useStore()
    // use loan amount part of the vue file class calling this computed function if available
    const loanAmount = store.getters.fieldValue('loanAmount', 'data', false, true)
    const loanTermType = loanAmount && loanAmount <= store.state.global.data.loanTermThreshold ? 'shortTerm' : 'longTerm'

    return store.state.global.mappings.loanTerms[loanTermType]
}

function maxLoanAmount() {
    const store = useStore()

    if (store.state.apply.data?.poorCredit?.value) {
        return store.getters.loanRange.poor_credit_max
    }

    if (store.state.apply.data?.isHomeowner?.value) {
        return store.getters.loanRange.homeowner_max
    }

    return store.getters.loanRange.max
}

function minLoanAmount() {
    const store = useStore()
    return store.getters.loanRange.min
}

function loanTermAlign(loanAmount, loanTerm) {
    const store = useStore()

    if (process.env.TERRITORY !== 'usa') {
        const loanTermType = loanAmount && loanAmount <= 999 ? 'shortTerm' : 'longTerm'
        const loanTermMapping = store.state.global.mappings.loanTerms[loanTermType]

        return find(loanTermMapping, term => {
            return term.value === parseInt(loanTerm)
        })?.value
    }

    return loanTerm
}

export { loanTerms, maxLoanAmount, minLoanAmount, loanTermAlign }
